// client/src/components/Skills/SkillsData.js
export const skills = [
    {
      name: 'React',
      logo: '/logos/react.png'
    },
    {
      name: 'Node.js',
      logo: '/logos/nodejs.png'
    },
    {
      name: 'MongoDB',
      logo: '/logos/mongodb.png'
    },
    {
      name: 'Three.js',
      logo: '/logos/three_js.png'
    },
    {
      name: 'Express',
      logo: '/logos/express.png'
    },
    {
      name: 'JavaScript',
      logo: '/logos/javascript.png'
    },
    {
      name: 'foundry',
      logo: '/logos/foundry.png'
    },
    {
      name: 'Solidity',
      logo: '/logos/Solidity-Logo-2.png'
    },
    {
      name: 'Nextjs',
      logo: '/logos/next-js.png'
    },
    {
      name: 'Mern',
      logo: '/logos/mern.png'
    }
  ];